import React from "react";
import { Link } from "react-router-dom";

const GovernmentContracts = () => {
  return (
    <div id="GovernmentContracts">
      {/* Hero */}
      <div id="header" style={{ minHeight: "50vh" }}>
        <div className="hero-inner">
          <div className="hero-eyebrow">State of Texas</div>
          <h1 className="hero-headline">Government Contracts</h1>
          <p className="hero-sub">
            Enteranet LLC holds active cooperative contracts with the Texas Department of Information Resources (DIR),
            enabling eligible public entities to procure our products and services at negotiated rates.
          </p>
        </div>
      </div>

      {/* Contract selector */}
      <section id="gov-contracts-section">
        <div className="container">
          <div className="section-header text-center">
            <div className="eyebrow">Active Contracts</div>
            <h2>Select a Contract</h2>
            <p className="section-sub">
              Click a contract below to view full details, eligible services, and ordering information.
            </p>
          </div>

          <div className="contract-hub-grid">

            <Link to="/government-contracts/dir-cpo-5373" className="contract-hub-card">
              <div className="contract-hub-logo">
                <img src="/img/dir_logo.png" alt="DIR Logo" />
              </div>
              <div className="contract-hub-badge">Active</div>
              <h3>DIR-CPO-5373</h3>
              <p className="contract-hub-category">Data Storage, Data Communications &amp; Networking Equipment</p>
              <p className="contract-hub-desc">
                Enterprise-grade IT networking infrastructure, structured cabling, wireless technologies,
                VoIP, cybersecurity, and professional services for the public sector.
              </p>
              <span className="contract-hub-cta">View Contract Details &rarr;</span>
            </Link>

            <Link to="/government-contracts/dir-cpo-6167" className="contract-hub-card">
              <div className="contract-hub-logo">
                <img src="/img/dir_logo.png" alt="DIR Logo" />
              </div>
              <div className="contract-hub-badge">Active</div>
              <h3>DIR-CPO-6167</h3>
              <p className="contract-hub-category">Law Enforcement &amp; Security Systems</p>
              <p className="contract-hub-desc">
                Surveillance cameras, access control systems, burglar alarms, intercom systems,
                and security infrastructure for government and public safety entities.
              </p>
              <span className="contract-hub-cta">View Contract Details &rarr;</span>
            </Link>

          </div>
        </div>
      </section>
    </div>
  );
};

export default GovernmentContracts;
